{
  "name": "react-refresh",
  "description": "React is a JavaScript library for building user interfaces.",
  "keywords": [
    "react"
  ],
  "version": "0.14.2",
  "homepage": "https://reactjs.org/",
  "bugs": "https://github.com/facebook/react/issues",
  "license": "MIT",
  "files": [
    "LICENSE",
    "README.md",
    "babel.js",
    "runtime.js",
    "cjs/",
    "umd/"
  ],
  "main": "runtime.js",
  "exports": {
    ".": "./runtime.js",
    "./runtime": "./runtime.js",
    "./babel": "./babel.js",
    "./package.json": "./package.json"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/facebook/react.git",
    "directory": "packages/react"
  },
  "engines": {
    "node": ">=0.10.0"
  },
  "devDependencies": {
    "react-16-8": "npm:react@16.8.0",
    "react-dom-16-8": "npm:react-dom@16.8.0",
    "scheduler-0-13": "npm:scheduler@0.13.0"
  }
}